<template>
  <BaseMenu
    :placement="'bottom'"
    :offset="[0,0]"
    :appendToBody="true"
  >
    <button id="module-btn" class="module-button">
      <SVGIcon
        :height="'32px'"
        :width="'32px'"
        :iconName="'apps'"
        :showHover="false"
        :showActive="true"
      />
    </button>
    <template #menu="{closeMenu}">
      <div id="module-menu" class="module-menu">
        <ul>
          <li>
            <button class="module-group-toggle" @click="toggleModuleGroup('dataset')">
              <span class="module-group-label">
                <SVGIcon :width="'28px'" :height="'28px'" :iconName="'database2'" />
                <span>Datasets</span>
              </span>
              <span class="module-group-chevron" :class="{ _open: openModuleGroup === 'dataset' }"><v-icon size="24">mdi-chevron-right</v-icon></span>
            </button>
          </li>
          <li v-if="openModuleGroup === 'dataset'" class="module-subitem">
            <BaseMenuButton
              :id="'module-menu__datasets'"
              :disabled="!currentProject"
              @click="Dataset(), closeMenu()"
            >
              <div class="li-row">
                <SVGIcon
                  :width="'22px'"
                  :height="'22px'"
                  :iconName="'database2'"
                />
                <div class="li-text">
                  <div class="li-text__title">Datasets</div>
                  <div class="li-text__description">Curate, upload, and share datasets</div>
                </div>
              </div>
            </BaseMenuButton>
          </li>
          <li v-if="openModuleGroup === 'dataset'" class="module-subitem">
            <BaseMenuButton
              :id="'module-menu__edit-audit-annotations'"
              :disabled="!currentProject"
              @click="AuditTasks(), closeMenu()"
            >
              <div class="li-row">
                <SVGIcon
                  :width="'22px'"
                  :height="'22px'"
                  :iconName="'tag'"
                />
                <div class="li-text">
                  <div class="li-text__title">Audit</div>
                  <div class="li-text__description">Manage labelling, audit, and more</div>
                </div>
              </div>
            </BaseMenuButton>
          </li>
          <li v-if="openModuleGroup === 'dataset'" class="module-subitem">
            <BaseMenuButton
              :id="'module-menu__snapshots'"
              @click="Snapshots(), closeMenu()"
            >
              <div class="li-row">
                <SVGIcon
                  :width="'22px'"
                  :height="'22px'"
                  :iconName="'database_sync'"
                />
                <div class="li-text">
                  <div class="li-text__title">Snapshots</div>
                  <div class="li-text__description">Save and restore data</div>
                </div>
              </div>
            </BaseMenuButton>
          </li>

          <li>
            <button class="module-group-toggle" @click="toggleModuleGroup('models')">
              <span class="module-group-label">
                <SVGIcon :width="'28px'" :height="'28px'" :iconName="'science'" />
                <span>Models</span>
              </span>
              <span class="module-group-chevron" :class="{ _open: openModuleGroup === 'models' }"><v-icon size="24">mdi-chevron-right</v-icon></span>
            </button>
          </li>
          <li v-if="openModuleGroup === 'models'" class="module-subitem">
            <BaseMenuButton
              :id="'module-menu__trainer'"
              :disabled="!currentProject"
              @click="Trainer(), closeMenu()"
            >
              <div class="li-row">
                <SVGIcon
                  :width="'22px'"
                  :height="'22px'"
                  :iconName="'science'"
                />
                <div class="li-text">
                  <div class="li-text__title">Experiments</div>
                  <div class="li-text__description">Train and validate models</div>
                </div>
              </div>
            </BaseMenuButton>
          </li>
          <li v-if="openModuleGroup === 'models'" class="module-subitem">
            <BaseMenuButton
              :id="'module-menu__profiler'"
              @click="Profiler(), closeMenu()"
            >
              <div class="li-row">
                <SVGIcon
                  :width="'22px'"
                  :height="'22px'"
                  :iconName="'chart_multiple'"
                />
                <div class="li-text">
                  <div class="li-text__title">Profilers</div>
                  <div class="li-text__description">Profiler home</div>
                </div>
              </div>
            </BaseMenuButton>
          </li>
          <!-- <li>
            <BaseMenuButton
              :id="'module-menu__validate-sessions'"
              @click="Validator(), closeMenu()"
            >
              <div class="li-row">
                <SVGIcon
                  :width="'28px'"
                  :height="'28px'"
                  :iconName="'compare'"
                />
                <div class="li-text">
                  <div class="li-text__title">Validate Sessions</div>
                  <div class="li-text__description">Compare model outputs</div>
                </div>
              </div>
            </BaseMenuButton>
          </li> -->
          <!-- <li>
            <BaseMenuButton
              @click="Automation(), closeMenu()"
            >
              <div class="li-row">
                <SVGIcon
                  :width="'28px'"
                  :height="'28px'"
                  :iconName="'auto_annotate'"
                />
                <div class="li-text">
                  <div class="li-text__title">Automation</div>
                  <div class="li-text__description">AI assisted annotation & segmentation</div>
                </div>
              </div>
            </BaseMenuButton>
          </li> -->
          <li>
            <button class="module-group-toggle" @click="toggleModuleGroup('advance')">
              <span class="module-group-label">
                <SVGIcon :width="'28px'" :height="'28px'" :iconName="'cloud_servers'" />
                <span>Advanced</span>
              </span>
              <span class="module-group-chevron" :class="{ _open: openModuleGroup === 'advance' }"><v-icon size="24">mdi-chevron-right</v-icon></span>
            </button>
          </li>
          <li v-if="openModuleGroup === 'advance'" class="module-subitem">
            <BaseMenuButton
              :id="'module-menu__cloud-instances'"
              @click="Servers(), closeMenu()"
            >
              <div class="li-row">
                <SVGIcon
                  :width="'22px'"
                  :height="'22px'"
                  :iconName="'cloud_servers'"
                />
                <div class="li-text">
                  <div class="li-text__title">Cloud Instances</div>
                  <div class="li-text__description">Manage virtual servers</div>
                </div>
              </div>
            </BaseMenuButton>
          </li>
          <li v-if="openModuleGroup === 'advance'" class="module-subitem">
            <BaseMenuButton
              :id="'module-menu__tasks'"
              @click="Tasks(), closeMenu()"
            >
              <div class="li-row">
                <SVGIcon
                  :width="'22px'"
                  :height="'22px'"
                  :iconName="'database_sync'"
                />
                <div class="li-text">
                  <div class="li-text__title">Tasks</div>
                  <div class="li-text__description">Background running tasks</div>
                </div>
              </div>
            </BaseMenuButton>
          </li>

          <li>
            <button id="module-menu__apps" class="module-group-toggle module-group-toggle--action" @click="Apps(); closeMenu()">
              <span class="module-group-label">
                <SVGIcon :width="'28px'" :height="'28px'" :iconName="'play_circle'" />
                <span>Apps</span>
              </span>
            </button>
          </li>

          <li v-if="showDebugSection">
            <button class="module-group-toggle" @click="toggleModuleGroup('debug')">
              <span class="module-group-label">
                <SVGIcon :width="'28px'" :height="'28px'" :iconName="'debug'" />
                <span>Debug</span>
              </span>
              <span class="module-group-chevron" :class="{ _open: openModuleGroup === 'debug' }"><v-icon size="24">mdi-chevron-right</v-icon></span>
            </button>
          </li>
          <li v-if="showDebugSection && openModuleGroup === 'debug'" class="module-subitem">
            <BaseMenuButton
              :id="'module-menu__schema-view'"
              @click="SchemaView(); closeMenu()"
            >
              <div class="li-row">
                <SVGIcon
                  :width="'22px'"
                  :height="'22px'"
                  :iconName="'log'"
                />
                <div class="li-text">
                  <div class="li-text__title">View Schema</div>
                  <div class="li-text__description">Open schema viewer page</div>
                </div>
              </div>
            </BaseMenuButton>
          </li>

        </ul>
        <hr>
        <ul>
          <li>
            <button :id="'module-menu__recycle'" class="module-group-toggle module-group-toggle--action" @click="RecycleBin(), closeMenu()">
              <span class="module-group-label">
                <SVGIcon
                  :width="'28px'"
                  :height="'28px'"
                  :iconName="'trash'"
                />
                <span>Recycle Bin</span>
              </span>
            </button>
          </li>
        </ul>
      </div>
    </template>
  </BaseMenu>
</template>

<script>
import BaseMenu from '@/components/BaseMenu.vue';
import SVGIcon from '@/components/SVGIcon.vue';
import BaseMenuButton from '@/components/BaseMenuButton.vue';
import {
  goto_datasets,
  goto_experiments,
  goto_taskboard,
  goto_servers,
  goto_snapshots,
  goto_recycle_bin,
  goto_apps,
  goto_tasks,
  goto_profiler_home,
} from '@/assets/js/links.js';

export default {
  name: 'ModuleMenuV2',
  data() {
    return {
      openModuleGroup: null,
    };
  },
  components: {
    SVGIcon,
    BaseMenu,
    BaseMenuButton,
  },
  computed: {
    currentProject() {
      return this.$store.state.projects.currentProject;
    },
    showDebugSection() {
      if (typeof window === 'undefined') {
        return false;
      }
      const host = window.location.hostname;
      return host === 'localhost' || host === 'dev.edgefirst.studio' || host === 'test.edgefirst.studio';
    },
  },
  methods: {
    Trainer() {
      if (this.currentProject) {
        goto_experiments(this.currentProject.id);
      }
    },
    Dataset() {
      if (this.currentProject) {
        goto_datasets(this.currentProject.id);
      }
    },
    Automation() {
      // TODO: Add goto_automation if available
      console.warn('Automation not yet implemented');
    },
    AuditTasks() {
      if (this.currentProject) {
        goto_taskboard(this.currentProject.id);
      }
    },
    Servers() {
      goto_servers();
    },
    RecycleBin() {
      goto_recycle_bin();
    },
    Snapshots() {
      goto_snapshots();
    },
    Apps() {
      goto_apps();
    },
    Tasks() {
      goto_tasks();
    },
    Profiler() {
      goto_profiler_home();
    },
    SchemaView() {
      this.$router.push('/schema-view');
    },
    toggleModuleGroup(groupKey) {
      this.openModuleGroup = this.openModuleGroup === groupKey ? null : groupKey;
    },
  },
};
</script>

<style lang="scss" scoped>

.module-button {
  display: flex;
  flex: 0 0 auto;
  height: 100%;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
  background: none;
  border: none;
  cursor: pointer;
  @include themify() {
    color: themed('header-dot-menu');
  }

  &:hover {
    @include themify() {
      background: themed('header-button-background-hover');
      color: themed('header-button-color-hover');
    }
  }

  &._active {
    @include themify() {
      background: themed('header-button-background-hover');
      color: themed('header-button-color-hover');
    }
  }
}

.li-row {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.li-text {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;

  &__title{
    display: flex;
    font-size: 1rem;
    font-weight: 600;
    margin-left: 12px;
  }

  &__description{
    display: flex;
    font-size: 0.8rem;
    font-weight: 600;
    margin-left: 12px;
    margin-top: 5px;
    text-align: left;
    @include themify() {
      color: rgba(61, 60, 60, 0.5);
    }
  }
}
.module-menu {
  width: 290px;

  .module-group-toggle {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 1rem;
    border: none;
    background: transparent;
    font-size: 1.08rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    color: #000000;
    cursor: pointer;
  }

  .module-group-toggle--action {
    text-transform: uppercase;
    letter-spacing: 0.03em;
    font-size: 1rem;
  }

  .module-group-label {
    display: inline-flex;
    align-items: center;
    gap: 10px;
  }

  .module-group-chevron {
    display: inline-flex;
    transition: transform 0.2s ease;

    &._open {
      transform: rotate(90deg);
    }
  }

  .module-subitem {
    padding-left: 1.4rem;

    :deep(.li-row) {
      align-items: flex-start;
    }

    :deep(.li-text__title) {
      color: #4a4a4a;
      font-size: 0.98rem;
      font-weight: 600;
    }

    :deep(.li-text__description) {
      color: #666666;
    }
  }
}
</style>
